<template>
    <div>
        <Logo></Logo>
        <div class="container-fluid bg-3 text-center">
            <div class="block_container drop">
                <div v-for="index in 220" :key="index" :class="`block block_${index}`"></div>
                <div class="clearfix"></div>
            </div>
        </div>
        <!-----------------contents-------------->
        <div class="main">

            <!------------------------------- steps partner organization---------------------------->

            <div class="animated_modal_contents stepspartner_contents none customScroll">
                <vue-custom-scrollbar class="scroll-indv">
                <div class="profile_container membersPartner">
                    <div v-for="(row, key) in dataPartnerPage" :key="key" :class="partnerClass(row.short_title)" :data-id="`${row.organizations_id}`" data-type="organizations" @click="modalLink(row.organizations_id, 'organizations')">
                        <img :src="`${IMAGEURL}cms/${row.image}`" style="@if(($memRow->short_title == 'EDCL') || ($memRow->short_title == 'ARGUS')) max-width: 70%; @endif">
                        <button class="member-details-link">Details</button>
                    </div>
                    <div class="profile_box light_gray none tabShow"></div>
                    <div class="profile_box light_gray profile_text none tabShow"></div>
                    <div class="profile_box light_gray none tabShow"></div>
                    <div class="profile_box light_gray profile_text none tabShow"></div>
                </div>
                </vue-custom-scrollbar>
            </div>
            <!------------------------------- end steps partner organization---------------------------->


            <div id="demo" data-animation="hierarchical-display" data-animation-in="tada" data-animationOut="zoomOut" data-speed="3">
                <a :href="`${baseUrl}`" id="close" data-value="hide"></a>
                <div id="mainTitle"></div>
                <div v-for="x in 62" :key="x" :id="`x${x}`"></div>
            </div>

        </div>
        <!--------------end main 3---------------->
        <div id="pageModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content pageModalContent">
                    <div class="modal-header noHeaderModal">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title"></h4>
                    </div>
                    <div class="modal-body">
                        <div v-if="modalData.type == 'organizations'">
                            <div class="row">

                                <div class="col-md-12">

                                    <div class="responsive-tabs-container accordion-xs accordion-sm">

                                        <ul class="nav nav-tabs responsive-tabs">

                                            <li class="tabLink tabLink-tab1 active" @click="shoHideTab('tab1')">
                                                <a href="javascript:;">{{modalData.dataRow.short_title}}</a>
                                            </li>
                                            <li class="tabLink tabLink-tab2" @click="shoHideTab('tab2')" v-if="modalData.projectRows.length > 0 || modalData.sectorRows.length > 0">
                                                <a href="javascript:;">Projects & Sectors</a>
                                            </li>
                                        </ul>


                                        <div class="tab-content text-justify">

                                            <div class="pageHeadingContainer">

                                                <div class="col-md-3 orgPageLogo">

                                                    <img :src="`${IMAGEURL}cms/${modalData.dataRow.image}`" alt="">

                                                </div>

                                                <div class="col-md-9 orgPageHeading">

                                                    <h2>{{modalData.dataRow.title}}</h2>
                                                    <div v-if="modalData.dataRow.url"><a :href="`http://${modalData.dataRow.url}`" target="_blank">{{modalData.dataRow.url}}</a></div>

                                                </div>

                                                <div class="clearfix"></div>

                                            </div>


                                            <div class="tab-pane active" id="tab1">
                                                <div v-html="modalData.dataRow.description"></div>
                                            </div>


                                            <div class="tab-pane" id="tab2" v-if="modalData.projectRows.length > 0 || modalData.sectorRows.length > 0">

                                                <div v-if="modalData.projectRows.length > 0"><h5>Projects</h5></div>

                                                <div class="">

                                                    <div v-for="(item, key) in modalData.projectRows" :key="key" :class="projectClass(item.projects_id, item.sort)" @click="modalLink(item.projects_id, 'projects')">
                                                        <div class="jumbotron">
                                                            {{item.short_title}}
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="clearfix"></div>

                                                <div v-if="modalData.sectorRows.length > 0">

                                                    <h5>Impact Sectors</h5>

                                                    <a v-for="(item, key) in modalData.sectorRows" :key="key" :href="href(item.sectors_id)" class="sectorLinks">{{item.name}}</a>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <!------------------projects---------------------->
                        <div v-if="modalData.type == 'projects'">

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="">
                                        <div class="">

                                            <div class="pageHeadingContainer">
                                                <div class="col-md-3 noPadding">
                                                    <div :class="projectClass(modalData.dataRow.projects_id, modalData.dataRow.sort)">


                                                        <div v-if="modalData.dataRow.projects_id == 9" class="jumbotron" style="cursor: auto">
                                                            <img :src="`${baseUrl}assets/images/telelogo.png`" class="responsive">
                                                        </div>

                                                        <div v-else class="jumbotron" style="cursor: auto">{{ modalData.dataRow.short_title }}</div>

                                                    </div>
                                                </div>
                                                <div class="col-md-9 orgPageHeading projectPageHeading">
                                                    <h2>{{modalData.dataRow.title}}</h2>
                                                    <h3>{{modalData.dataRow.tag}}</h3>

                                                    <div v-if="modalData.dataRow.projects_id == 9">
                                                        <a href="http://teledaktar.org/" target="_blank">www.teledaktar.org</a>
                                                    </div>

                                                </div>
                                                <div class="clearfix"></div>
                                            </div>

                                            <div :class="detailsColorBox(modalData.dataRow.sort)">

                                                <h4 class="mt5">OVERVIEW</h4>
                                                <div v-html="modalData.dataRow.description"></div>
                                            </div>

                                            <div class="">
                                                <a href="#" class="example-image-link" data-lightbox="example-1">
                                                    <span class="roll"></span>
                                                    <img :src="`${IMAGEURL}cms/${modalData.dataRow.image}`" class="responsive example-image">
                                                </a>

                                                <p class="text-center" v-if="modalData.dataRow.image_text">{{modalData.dataRow.image_text}}</p>

                                            </div>

                                            <div class="">
                                                <h4>IMPACT SECTORS</h4>
                                                <ul class="list">
                                                    <li v-for="(item, key) in modalData.sectorRows" :key="key">
                                                        <a :href="href(item.sectors_id)">{{item.name}}</a>
                                                    </li>

                                                </ul>
                                            </div>

                                            <div class="members">
                                                <h4>STEPs MEMBERS</h4>

                                                <div v-for="(item, key) in modalData.projectMembers" :key="key" class="col-md-3 col-sm-3 memberLogo " @click="modalLink(item.organizations_id, 'organizations')">
                                                    <img :src="`${IMAGEURL}cms/${item.image}`" class="responsive ">
                                                </div>


                                                <div v-if="modalData.dataRow.projects_id == 4 || modalData.dataRow.projects_id == 8" class="col-md-3 col-sm-3 memberLogo triggerLink" data-trigger="pub">
                                                    <img :src="`${baseUrl}assets/images/thesteps.png`" class="responsive ">
                                                </div>

                                            </div>
                                            <div class="clearfix"></div>

                                            <div class="partner" v-if="modalData.projectPartners.length > 0">
                                                <h4>PROJECT PARTNERS</h4>

                                                <div v-for="(item, key) in modalData.projectPartners" :key="key" class="col-md-3 col-sm-3 partnerLogo " @click="modalLink(item.organizations_id, 'organizations')">
                                                    <img :src="`${IMAGEURL}cms/${item.image}`" class="responsive ">
                                                </div>

                                            </div>

                                            <div class="clearfix"></div>
                                            <div class="impact">
                                                <h4>IMPACT</h4>
                                                <div v-html="modalData.dataRow.impact"></div>
                                            </div>
                                            <div class="clearfix"></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <!------------------projects---------------------->
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <input class="blockWidth" type="hidden" value="95">
    </div>
</template>

<script>
  import Logo from './Logo.vue';
  import vueCustomScrollbar from 'vue-custom-scrollbar';

  export default {
    components: {
      Logo,
      vueCustomScrollbar,
    },
    data() {
      return {
        blockWidth: 95,
        blockHeight: 95,
        dataPartnerPage: [],
        modalData: {},
      };
    },
    mounted() {
      this.getPartnersPageData();
      const that = this;
      window.addEventListener(`resize`, function () {
        const width = $(window)
          .width();
        that.resize_block(width, this.blockWidth);
        if (width > 800) {
          location.reload();
        }
      });

      let effect = 'zoomInUp';
      $('#demo').children().addClass(effect + ' animated');
      let screen_width = '';
      screen_width = $(window).width();
      $(".main").css("left", '0px');

      $('#demo').hierarchicalDisplay({
          speed: 6,
        });
      setTimeout(function () {
        $("#demo").css("background", '#ffffff');
        $('.stepspartner_contents').fadeIn();
        $('#animationOut').after('<i class="fa fa-times fake_close" aria-hidden="true"></i>');
      }, 1500);
    },
    methods: {
      getPartnersPageData() {
        this.$http.get(`getPartnersPageData`)
          .then((response) => {
            this.dataPartnerPage = response.data;
          })
          .catch((error) => {
            if (error.response.status) {
              this.dataPartnerPage = [];
            }
          });
      },
      modalLink(cmsId, ContentType) {
        $(`#loading`).show();
        const formData = {
          cms_id: cmsId,
          type: ContentType,
        };
        this.$http.post(`getCmsRow`, formData)
          .then((response) => {
            console.log(response.data);
            this.modalData = response.data;
            this.modalData.type = ContentType;
            $(`#pageModal`).modal(`show`);
            $(`#loading`).hide();
          })
          .catch((error) => {
            if (error.response.status) {
              this.modalData = {};
            }
          });
      },
      bglobalPage() {
        $(`#loading`);
        $(`#bglobalModal`).modal(`show`);
        $(`#loading`).hide();
      },
      set_html(array, total, menuStart) {
        for (var i = 0; i < total; i++) {
          const menuNo = i + menuStart;
          const html = $('.menu' + menuNo)
            .html();
          $('.block_' + array[i])
            .html(html);
        }
      },
      detailsColorBox(sort) {
        let classString = `detailsColorBox text-justify  `;
        if (sort % 2 === 0) {
          classString += ` bgBlue`;
        } else {
          classString += ` bgDeepYellow`;
        }
        return classString;
      },
      projectClass(projectsId, sort) {
        let classString = `projectRoundBox projectRoundBoxSmall `;
        classString += `color` + sort;
        if (projectsId === 8) classString += ` font9`;
        return classString;
      },
      partnerClass(short_title) {
        let stitle = short_title.toLowerCase();
        let classString = `profile_box light_gray pr modalLink  ` + stitle;
        return classString;
      },
      href(sectorId) {
        let string = ``;
        if (sectorId) {

          if (sectorId === 1) {
            string = this.baseUrl+`education`;
          } else if (sectorId === 3) {
            string = this.baseUrl+`financial-inclusion`;
          } else if (sectorId === 4) {
            string = this.baseUrl+`health`;
          } else if (sectorId === 5) {
            string = this.baseUrl+`gender-equality`;
          } else if (sectorId === 6) {
            string = this.baseUrl+`culture`;
          } else if (sectorId === 7) {
            string = this.baseUrl+`environment`;
          }
        } else {
          string = null;
        }
        return string;
      },
      shoHideTab(id) {
        $(`.tabLink`).removeClass(`active`);
        $(`.tab-pane`).removeClass(`active`);
        $(`.tabLink-` + id).addClass(`active`);
        $(`#` + id).addClass(`active`);
      },
      resize_block(width, blockWidth) {
        let screenWidth = 0;
        let blockCount = 0;
        let newBlockSize = 0;
        screenWidth = width - 10;
        blockCount = screenWidth / blockWidth;
        blockCount = Math.round(blockCount);
        newBlockSize = screenWidth / blockCount;
        newBlockSize = newBlockSize - .25;
        $('.block')
          .css({ 'width': newBlockSize });
        this.blockWidth = newBlockSize;
        $(".blockWidth")
          .val(newBlockSize);

        let height = $(window)
          .height();
        if (height >= 1025) {
          $('.block_container')
            .css({ 'height': height + 'px' });
        }
      },
    },
  };
</script>
